module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col",
    class: _vm.classObj
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-704088cd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/grid/col.vue
// module id = 457
// module chunks = 1